{
  "version": 1,
  "asset_id": "9282eff9-260a-4bb6-88d6-851af2133360",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/9282eff9-260a-4bb6-88d6-851af2133360/beverly-hills-shingle-replacement-in-progress-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/9282eff9-260a-4bb6-88d6-851af2133360/beverly-hills-shingle-replacement-in-progress-480w.avif",
  "original_filename": "beverly-hills-shingle-replacement-in-progress-480w.avif",
  "size": 14225,
  "content_type": "image/avif",
  "created_at": "2026-07-29T14:06:35Z"
}
